var appBaseApiUrl = '/eStories/rest';

function isProduction() {
    return window.location.host.indexOf('www.estories.com') == 0;
}
